/* unplugin-vue-components disabled */import { render } from "./SideModalPartnersCard.vue?vue&type=template&id=6dedf601&scoped=true"
import script from "./SideModalPartnersCard.vue?vue&type=script&lang=js"
export * from "./SideModalPartnersCard.vue?vue&type=script&lang=js"

import "./SideModalPartnersCard.vue?vue&type=style&index=0&id=6dedf601&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dedf601"]])

export default __exports__